import React from "react";
import { Link } from "react-router-dom";
import { HiChevronRight } from "react-icons/hi";

const BreadCrumbs = ({ crumbs, className }) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center py-2 ${className}`}
    >
      <ol className="inline-flex items-center flex-wrap">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          const isClickable = crumb.link && crumb.link.trim() !== "";

          return (
            <React.Fragment key={index}>
              <li className="inline-flex items-center">
                {isClickable ? (
                  <Link
                    to={crumb.link}
                    className={`
                      text-sm font-medium transition-colors duration-200
                      ${
                        isLast
                          ? "text-blue-600 font-semibold"
                          : "text-gray-600 hover:text-blue-500"
                      }
                    `}
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span
                    className={`
                      text-sm font-medium
                      ${
                        isLast ? "text-blue-600 font-semibold" : "text-gray-600"
                      }
                    `}
                  >
                    {crumb.label}
                  </span>
                )}
              </li>

              {!isLast && (
                <li className="mx-2">
                  <HiChevronRight
                    className="h-4 w-4 text-gray-400"
                    aria-hidden="true"
                  />
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadCrumbs;
